import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "https://attendanceapi.gensparc.com";
// const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

const instance = axios.create({
  baseURL: API_URL,
});

// Attach auth token to every request if available.
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("authToken");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default instance;
